// extracted by mini-css-extract-plugin
export default {"select-block-root":"SelectListBlock_select-block-root__-HbSu"};